import barbaraCantoAvatar from "app/assets/images/barbaraCantoAvatar.jpg";
import veroSutilAvatar from "app/assets/images/veroSutilAvatar.jpg";
import andreaErrazurizAvatar from "app/assets/images/andreaErrazurizAvatar.png";
import reimundoMusriAvatar from "app/assets/images/reimundoMusriAvatar.jpg";
import isiDeLaSottaAvatar from "app/assets/images/isiDeLaSottaAvatar.jpg";
import franKegevicAvatar from "app/assets/images/franKegevicAvatar.jpg";
import amoyanoAvatar from "app/assets/images/amoyanoAvatar.jpeg";
import valeSanchezAvatar from "app/assets/images/valeSanchezAvatar.png";
import pilarDominguezAvatar from "app/assets/images/pilarDominguezAvatar.jpeg";

import { TTestimonial } from "./types";

export const TESTIMONIALS: TTestimonial[][] = [
  [
    {
      avatar: barbaraCantoAvatar,
      name: "Bárbara Cantó",
      role: "Fundadora de Woolie Beanies",
      description: `Grafito es una súper buena solución para los emprendedores que
       buscan implementar de forma rápida y eficaz un sitio web con Ecommerce. El 
       equipo detrás es súper buena onda y apañador para resolver todo tipo de
       inconvenientes y abierto a dar mejoras constantes a su servicio. Recomendados 100%.`,
    },

    {
      avatar: isiDeLaSottaAvatar,
      name: "Isidora de la Sotta",
      role: "Fundadora de Etnik y Minga Kids",
      description: `Gracias a Grafito tengo una mejor forma de mostrar todos
       mis productos en el mismo lugar y así facilitar la compra para mis clientes,
       también me ha permitido llegar a un público más amplio. Increíble plataforma
       donde podrás encontrar diferentes emprendimientos chilenos.`,
    },

    {
      avatar: andreaErrazurizAvatar,
      name: "Andrea Errazuriz",
      role: "Fundadora de Lambra",
      description: `Lo mejor Grafito! Una plataforma fácil de usar y perfecta para
       mostrar mi arte! Una buenísima manera de visibilizar el diseño chileno.`,
    },
  ],
  [
    {
      avatar: veroSutilAvatar,
      name: "Verónica Sutil",
      role: "Fundadora de Ropa Verónica Sutil",
      description: `A través de Grafito he podido mostrar mi marca al mundo. Me permite sacar
       el máximo potencial de mis productos, compartirlos con mis seguidores y permitirles
       comprar súper rápida y fácilmente. Increíble proyecto!`,
    },
    {
      avatar: reimundoMusriAvatar,
      name: "Reimundo Musri",
      role: "Fundador de Reimundo A. Musri",
      description: (
        <>
          Grafito me ha ayudado a entender mejor mi negocio{" "}
          <span role="img" aria-label="">
            🚀
          </span>{" "}
          Tiene potentes herramientas que me han facilitado enormemente el
          trabajo y me han permitido llegar de manera más efectiva a mis
          clientes. Es muy fácil de usar y amigable.
        </>
      ),
    },
    {
      avatar: pilarDominguezAvatar,
      name: "Pilar Domínguez",
      role: "Fundadora de Macho Cabrío",
      description: `Estuvimos buscando por mucho tiempo opciones para manejar
       nuestro negocio online y Grafito fue de todas maneras la mejor. Sus tarifas
       son perfectas para emprendedores y realmente nos han visibilizado como marca
       y dado una excelente experiencia de compra para nuestros clientes.`,
    },
  ],

  [
    {
      avatar: amoyanoAvatar,
      name: "Andrés Moyano",
      role: "Fundador A. Moyano",
      description: (
        <>
          Con Grafito he podido ser mucho más creativo, ordenar cada unos de mis
          proyectos y compartirlos de manera muy simple con mis seguidores,
          permitiéndoles comprar rápida y fácilmente{" "}
          <span role="img" aria-label="">
            🎨
          </span>
          {".  "} Es una plataforma donde podrás encontrar a cientos de
          diseñadores, artistas y creativos chilenos.
        </>
      ),
    },

    {
      avatar: valeSanchezAvatar,
      name: "Valentina Sanchez",
      role: "Fundadora de Ohana Eyewear",
      description: (
        <>
          Grafito me da la oportunidad de ofrecerles una manera fácil y segura
          de comprar a mis clientes! Es una plataforma súper amigable, perfecta
          para gente descubra nuevas marcas con productos creativos y de
          emprendedores locales.
        </>
      ),
    },

    {
      avatar: franKegevicAvatar,
      name: "Francisca Kegevic",
      role: "Co-fundadora de Hybrida",
      description: (
        <>
          Gracias a Grafito pudimos tener una plataforma muy amigable para que
          nuestras clientas puedan vitrinear y comprar. Ha hecho mucho más
          rápido su proceso de compra, lo que nos ha ayudado a crecer mucho como
          marca{" "}
          <span role="img" aria-label="">
            💛
          </span>
        </>
      ),
    },
  ],
];
